/* eslint-disable @typescript-eslint/ban-ts-comment */
// eslint-disable-next-line import/named
import { Field, FieldProps, useFormikContext } from 'formik'
import * as React from 'react'
import ErrorLabel from 'ui/atoms/ErrorLabel'
import TextAreaField, {
  type Props as TextAreaFieldProps,
} from 'ui/molecules/TextAreaField'

type Props = {
  name: string
} & TextAreaFieldProps

function FormikTextField({ name, ...rest }: Props) {
  const { submitCount } = useFormikContext()

  return (
    <Field name={name}>
      {({ field, meta }: FieldProps) => {
        const hasError = (meta.touched || submitCount > 0) && meta.error

        return (
          <div>
            <TextAreaField
              {...rest}
              // @ts-ignore
              useEvent
              // @ts-ignore
              hasError={hasError}
              name={field.name}
              onBlur={field.onBlur}
              onChange={field.onChange}
              value={field.value}
            />
            <ErrorLabel>{hasError && meta.error}</ErrorLabel>
          </div>
        )
      }}
    </Field>
  )
}

export default FormikTextField
